import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import common from '../../styles/common.js';
import { classMap } from 'lit/directives/class-map.js';

// @TODO Mobile

const getIdForHeader = (header, main) => {
  let id = header.textContent
    .trim()
    .toLowerCase()
    .replace(/[^a-z]/gi, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-|-$/g, '')
    || 'heading1';

  let currentUsingId = main.querySelector(`#${id}`);

  while (currentUsingId && currentUsingId !== header) {
    id = id.replace(/[0-9]?$/, v => parseInt(v || 1) + 1);
    currentUsingId = main.querySelector(`#${id}`)
  }

  return id;
};

@customElement('table-of-contents')
class TableOfContents extends LitElement {
  static styles = [
    common,
    css`      
      :host {
        position: sticky;
        left: 100%;
        top: 20px;
        max-height: 90vh;
        display: block;
        padding: 21px 0 16px;
        background: var(--main-background);
        float: right;
        max-width: 300px;
        overflow: hidden;    
        margin-top: 20px;
      }
      
      #wrapper {
        margin-left: 0;
        transition: margin-left .5s;
        width: 100%;
      }
      
      :host([collapsed]) #wrapper {
        margin-left: 100%;
      }
      
      p {
        border-bottom: 1px solid #CCC;
        padding: 0 0 4px 18px;
        margin: 0 50px 0 0;
      }
      
      #arrow {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        width: 50px;
        border-radius: 0 25px 25px 0;
        height: 50px;
        border: solid #CCC;
        border-width: 1px 1px 1px 0;
        line-height: 45px;
        text-align: right;
        padding: 0 15px;
        background: #FFF;
        transition: right .5s;
      }
      
      :host([collapsed]) #arrow {
        border-width: 1px 0 1px 1px;
        border-radius: 25px 0 0 25px;
        right: -20px;
        width: 60px;
        text-align: left;
      }
      
      :host([collapsed]) #arrow:hover {
        right: 0;
      }
      
      a {
        color: inherit;
        text-decoration: none;
        font-size: .9em;
        cursor: pointer;
      }
      
      a:hover {
        text-decoration: underline;
      }
      
      ul {
        list-style: none;
        padding: 8px 20px;
        margin: 0;
        border-left: 1px solid #CCC;
      }
      
      li {
        color: #666;
      }
      
      li:first-child {
        color: #AAA;
      }
      
      li.level2 {
        margin-left: 16px;
      }
    `
  ];

  @property({ attribute: false })
  items = [];

  @property({ reflect: true })
  collapsed = null;

  connectedCallback() {
    super.connectedCallback();

    const main = this.parentNode;
    const headers = main.querySelectorAll('h2, h3');

    this.items = headers::Array.prototype.map(header => {
      if (!header.id) {
        header.id = getIdForHeader(header, main);
      }

      return {
        text: header.textContent.trim(),
        id: header.id,
        level: parseInt(header.tagName.slice(-1)) - 1
      };
    });
  }

  render() {
    if (this.items.length < 2) return;

    return html`
      <div id="wrapper">
        <p>On this page</p>
        <i id="arrow" 
           @click=${this.handleToggleCollapse}
           class=${classMap({ 
             'bi-chevron-double-right': this.collapsed === null, 
             'bi-chevron-double-left': this.collapsed === ''
           })}
        ></i>
        <ul>
          <li>
            <a class="bi-arrow-up" href=${'#'}>
              Back to top
            </a>
          </li>
          ${this.items.map(({ text, id, level }) => html`
            <li class=${classMap({ level1: level === 1, level2: level === 2 })}>
              <a href=${`#${id}`}>${text}</a>
            </li>
          `)}
        </ul>
      </div>
    `;
  }

  handleToggleCollapse() {
    this.collapsed = this.collapsed === '' ? null : '';
  }
}